<template>
    <div>
        <!-- Footer Section start -->
        <section class="footer team">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <ul class="nav flex-column">
                            <li class="nav-item p-0"><a class="nav-link" href="tentang-kami">Tentang Kami</a></li>
                            <li class="nav-item p-0"><a class="nav-link" href="hubungi-kami">Hubungi Kami</a></li>
                            <li class="nav-item p-0"><a class="nav-link" href="faq">FAQ</a></li>
                            <li class="nav-item p-0"><a class="nav-link" href="kebijakan-privasi">Kebijakan Privasi</a></li>
                            <li class="nav-item p-0"><a class="nav-link" href="syarat-dan-ketentuan">Syarat Dan Ketentuan</a></li>
                        </ul>
                    </div>
                    <div class="col-md-6">
                        <p class="text-uppercase h5 mb-3">PT. Efunding Teknologi Keuangan</p>
                        <address>
                            Ruby Commercial TB21 - Summarecon Bekasi, <br>
                            Jalan Bulevar Selatan, RT.003/RW.005, Kelurahan Marga Mulya,<br>
                            Kecamatan Bekasi Utara, Kota Bekasi, Jawa Barat 17143. <br>
                            Customer Support : +62 818-227-070 <br>
                            Support@efunding.id
                        </address>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-md-12">
                        <p class="mb-1 font-weight-bold" style="font-size: 13px;">Disclaimer:</p>
                        <p style="font-size: 13px; line-height: 1.6; color: #777; text-align: justify;">
                            Efunding merupakan penyelenggara agregasi jasa keuangan yang terdaftar di OJK. Oleh karena itu, produk dan/atau layanan jasa keuangan yang ditawarkan bukan merupakan produk dan/atau layanan jasa keuangan yang diterbitkan oleh Efunding dan Efunding tidak bertanggung jawab atas tuntutan dan risiko terkait produk dan/atau layanan LJK dan/atau pihak yang melakukan kegiatan di sektor jasa keuangan.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center mt-3">
                        <p>© <span id="year"></span> efunding.id. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- Footer Section End -->
        <!-- Tap on Top -->
        <div class="tap-top">
            <div>
                <i class="fa fa-angle-double-up"></i>
            </div>
        </div>
        <!-- Tap on Ends -->
        <!-- <color/> -->
    </div>
</template>

<script>
export default {
    name: 'Footer',
    mounted() {
        document.getElementById("year").textContent = new Date().getFullYear();
    }
}
</script>

<style scoped>
.copyright-section .sub-footer a {
    color: #777;
}

.copyright-section .sub-footer p {
    text-align: left;
    padding: 0;
}

.copyright-section .sub-footer address {
    color: #777;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue